import React, { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useAuth } from "../context/AuthContext";
import { FiUser, FiMail, FiLock } from "react-icons/fi";

const Signup = () => {

  const navigate = useNavigate();
  const { login } = useAuth();

  const [form, setForm] = useState({
    name: "",
    email: "",
    password: ""
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    if (!form.name || !form.email || !form.password) {
      return toast.error("Please fill all fields");
    }

    try {

      setLoading(true);

      const res = await axios.post("/api/auth/signup", form);

      login(res.data.user);

      toast.success("Account created successfully");

      navigate("/");

    } catch (error) {

      toast.error(
        error.response?.data?.message || "Signup failed"
      );

    } finally {
      setLoading(false);
    }
  };

  return (

    <div className="min-h-screen flex items-center justify-center px-4 bg-gradient-to-br from-gray-900 via-black to-gray-800">

      <motion.div
        initial={{ opacity: 0, y: 60 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="backdrop-blur-xl bg-white/10 border border-white/20 shadow-2xl rounded-3xl p-10 w-full max-w-md text-white"
      >

        <h2 className="text-4xl font-bold text-center mb-2 tracking-wide">
          Create Account
        </h2>

        <p className="text-center text-gray-300 mb-8 text-sm">
          Join our luxury bridal collection
        </p>

        <form onSubmit={handleSubmit} className="space-y-6">

          {/* Name */}
          <div className="relative">

            <FiUser className="absolute left-4 top-4 text-gray-400" />

            <input
              type="text"
              name="name"
              placeholder="Full Name"
              value={form.name}
              onChange={handleChange}
              className="w-full pl-12 pr-4 py-3 bg-white/10 border border-white/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500 transition"
            />

          </div>

          {/* Email */}
          <div className="relative">

            <FiMail className="absolute left-4 top-4 text-gray-400" />

            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={form.email}
              onChange={handleChange}
              className="w-full pl-12 pr-4 py-3 bg-white/10 border border-white/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500 transition"
            />

          </div>

          {/* Password */}
          <div className="relative">

            <FiLock className="absolute left-4 top-4 text-gray-400" />

            <input
              type="password"
              name="password"
              placeholder="Password"
              value={form.password}
              onChange={handleChange}
              className="w-full pl-12 pr-4 py-3 bg-white/10 border border-white/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500 transition"
            />

          </div>

          {/* Button */}
          <motion.button
            whileTap={{ scale: 0.95 }}
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-yellow-400 to-yellow-600 text-black font-semibold py-3 rounded-lg shadow-lg hover:shadow-yellow-500/40 transition"
          >

            {loading ? "Creating Account..." : "Create Account"}

          </motion.button>

        </form>

        <p className="text-center mt-6 text-sm text-gray-300">

          Already have an account?{" "}

          <Link
            to="/login"
            className="text-yellow-400 hover:text-yellow-300 font-semibold"
          >
            Login
          </Link>

        </p>

      </motion.div>

    </div>

  );
};

export default Signup;